import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { RfpProfessionalOneSkeletonLayout } from '@/components/modules/pages/rfp/professional/Layout/RfpProfessionalOneSkeletonLayout';
import { RfpProfessionalOneContentSkeletonCard } from '@/components/modules/pages/rfp/professional/Surface/RfpProfessionalOneContentSkeletonCard';
/**
 * コンサルタント：案件詳細ページを表示した際のスケルトンコンポーネント
 * @constructor
 */
export const RfpProfessionalOneSkeleton = () => (_jsx(RfpProfessionalOneSkeletonLayout, { skeletonComponent: _jsx(RfpProfessionalOneContentSkeletonCard, {}) }));
